import { handleActions, combineActions } from 'redux-actions'
import types from './types'

const INITIAL_STATE = {
  isLoading: true,
  data: {
    myRelatedNoticesDrafts: {
      count: 0,
      rows: [],
    },
    myRelatedNoticesPublish: {
      count: 0,
      rows: [],
    },
  },
}

const beginLoading = combineActions(types.LOAD_MY_RELATED_NOTICES)

const stopLoading = combineActions(
  types.LOAD_MY_RELATED_NOTICES_SUCCESS,
  types.LOAD_MY_RELATED_NOTICES_FAIL
)

const reducer = handleActions(
  {
    [beginLoading]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [stopLoading]: (state) => ({
      ...state,
      isLoading: false,
    }),
    [types.LOAD_MY_RELATED_NOTICES_SUCCESS]: (
      state,
      {
        payload: {
          data: { data },
        },
      }
    ) => ({
      ...state,
      data,
    }),
    [types.CLEAR_STATE]: () => INITIAL_STATE,
  },
  INITIAL_STATE
)

export default reducer
